import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { TfiAngleLeft, TfiAngleRight } from "react-icons/tfi";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className=" absolute top-[22px] right-[-28px]"
      style={{ display: "block" }}
      onClick={onClick}
    >
      <TfiAngleRight className="cursor-pointer" />
    </div>
  );
}
function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="absolute bottom-[30px] left-[-38px]"
      style={{ display: "block" }}
      onClick={onClick}
    >
      <TfiAngleLeft className="cursor-pointer" />
    </div>
  );
}
const PopupSlider = () => {
  let [dotsActive, setDotsActive] = useState(0);
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (prev, next) => {
      setDotsActive(next);
    },
  };
  return (
    <div className="w-[303px]">
      <Slider {...settings}>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8 border-2 border-solid border-primary"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/popup/sliderimg.png"
              alt="sliderimg"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/auction_listing/auctionimg1.png"
              alt="auctionimg1"
            />
          </div>
        </Link>
        <Link to="#">
          <div>
            <img
              className="h-8 w-8"
              src="assets/images/auction_listing/auctionimg1.png"
              alt="auctionimg1"
            />
          </div>
        </Link>
      </Slider>
    </div>
  );
};

export default PopupSlider;
